import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ResponseList } from '@outlaw/core';
import { Observable } from 'rxjs';
import { CommunityConfigService } from '../util';
import { CommunityItem, FeedParams, CommonFeedParams } from '../../interfaces';

@Injectable({ providedIn: 'root' })
export class FeedService {
  #http = inject(HttpClient);
  #internalApi = inject(CommunityConfigService).internalApi;

  postUrl = this.#internalApi.postUrl;

  userFeed = (params: CommonFeedParams): Observable<ResponseList<CommunityItem>> => {
    const postTypes = params?.post_types?.join(',');

    const httpParams = new HttpParams({
      fromObject: {
        ...(params?.page && { page: params.page.toString() }),
        ...(params?.limit && { limit: params.limit.toString() }),
        ...(postTypes && { post_types: postTypes }),
      },
    });

    return this.#http.get<ResponseList<CommunityItem>>(`${this.postUrl}/user_feed/${params.id}/`, {
      params: httpParams,
    });
  };

  commonFeed = (params: CommonFeedParams): Observable<ResponseList<CommunityItem>> => {
    const postTypes = params?.post_types?.join(',');

    const httpParams = new HttpParams({
      fromObject: {
        ...(params?.page && { page: params.page.toString() }),
        ...(params?.limit && { limit: params.limit.toString() }),
        ...(postTypes && { post_types: postTypes }),
      },
    });

    return this.#http.get<ResponseList<CommunityItem>>(`${this.postUrl}/common_feed/`, {
      params: httpParams,
    });
  };

  recsFeed = (params: FeedParams): Observable<ResponseList<CommunityItem>> => {
    const httpParams = new HttpParams({
      fromObject: {
        ...(params?.page && { page: params.page.toString() }),
        ...(params?.limit && { limit: params.limit.toString() }),
        ...(params.sort_by && { sort_by: params.sort_by }),
      },
    });
    return this.#http.get<ResponseList<CommunityItem>>(`${this.postUrl}/likes/${params.id}/`, {
      params: httpParams,
    });
  };

  discussionsAllFeed = (params: FeedParams): Observable<ResponseList<CommunityItem>> => {
    const httpParams = new HttpParams({
      fromObject: {
        ...(params?.page && { page: params.page.toString() }),
        ...(params?.limit && { limit: params.limit.toString() }),
        ...(params.sort_by && { sort_by: params.sort_by }),
      },
    });
    return this.#http.get<ResponseList<CommunityItem>>(`${this.postUrl}/with_comments/${params.id}/`, {
      params: httpParams,
    });
  };

  userComments = (params: FeedParams): Observable<ResponseList<CommunityItem>> => {
    const httpParams = new HttpParams({
      fromObject: {
        ...(params?.page && { page: params.page.toString() }),
        ...(params?.limit && { limit: params.limit.toString() }),
        ...(params?.sort_by && { sort_by: params.sort_by }),
      },
    });

    return this.#http.get<ResponseList<CommunityItem>>(`${this.postUrl}/user/comments/${params.id}/`, {
      params: httpParams,
    });
  };

  groupWithCommentsFeed = (
    params: FeedParams,
  ): Observable<ResponseList<CommunityItem>> => {
    const httpParams = new HttpParams({
      fromObject: {
        ...(params?.page && { page: params.page.toString() }),
        ...(params?.limit && { limit: params.limit.toString() }),
        ...(params?.sort_by && { sort_by: params.sort_by }),
      },
    });
    return this.#http.get<ResponseList<CommunityItem>>(
      `${this.postUrl}/group_with_comments/${params.id}/`,
      {
        params: httpParams,
      },
    );
  };

  groupFeed = (params: FeedParams): Observable<ResponseList<CommunityItem>> => {
    const postTypes = params?.post_types?.join(',');

    const httpParams = new HttpParams({
      fromObject: {
        ...(params?.page && { page: params.page.toString() }),
        ...(params?.limit && { limit: params.limit.toString() }),
        ...(params?.sort_by && { sort_by: params.sort_by }),
        ...(params?.user_uuid && { user_uuid: params.user_uuid }),
        ...(postTypes && { post_types: postTypes }),
      },
    });

    return this.#http.get<ResponseList<CommunityItem>>(`${this.postUrl}/community_group_feed/feed/${params.id}/`, {
      params: httpParams,
    });
  };
}
